import { linkOptions } from '@luminovo/design-system';

/** The pages the Templates entries stand for, in the order of the Templates sidebar. */
export const templateLinks = {
    sourcing: linkOptions({ to: '/templates/sourcing' }),
    quoteRequest: linkOptions({ to: '/templates/quote-request' }),
    email: linkOptions({ to: '/templates/email' }),
    calculation: linkOptions({ to: '/templates/calculation' }),
    manufacturing: linkOptions({ to: '/manufacturing/activities' }),
    pcbSpecification: linkOptions({ to: '/templates/pcb-specification' }),
    export: linkOptions({ to: '/templates/export' }),
    flexibleCalculation: linkOptions({ to: '/templates/flexible-calculation' }),
    quotation: linkOptions({ to: '/templates/quotation' }),
};
